import { CircleDollarSign } from 'lucide-react'

import { ScrollArea } from '@/components/scroll-area'
import { formatNumberToCurrency } from '@/helper/currency'
import { Installments } from '@/models/finances-tab'
import { FormatLocaleDate } from '@/utils/format-locale-date'

import { InstallmentData } from './installment-data'

interface MonthlyStatementProps {
  isSponsoring: boolean
  getCurrencyValue(value?: number | null): string
  totalNetValue: number | undefined
  installments: Installments[] | undefined
}

export function MonthlyStatement({
  installments,
  totalNetValue,
  isSponsoring,
  getCurrencyValue,
}: MonthlyStatementProps) {
  return (
    <div className="flex flex-col gap-4 sm:gap-8">
      <h3 className="text-bios-800 text-xl font-black sm:mb-2 2xl:text-2xl">
        Extrato total por mês
      </h3>

      <h3 className="text-monochromatic-400 text-xl font-bold 2xl:text-2xl">
        Patrocínio total
      </h3>

      <div className="border-monochromatic-200 flex items-center gap-6 border-b pb-8 xl:gap-14">
        <CircleDollarSign className="text-monochromatic-300 h-9 w-9" />
        <div className="flex flex-col gap-1">
          <p className="text-monochromatic-500 text-base">
            {isSponsoring ? 'Valor total a repassar' : 'Valor total a receber'}
          </p>
          <p className="text-bios-600 text-base font-semibold">
            {getCurrencyValue(totalNetValue)}
          </p>
        </div>
      </div>

      <div className="max-h-130 overflow-x-auto lg:overflow-x-visible">
        <div className="h-full min-w-150">
          <ScrollArea className="h-full">
            <div className="flex flex-col gap-8 pr-3 sm:pr-10">
              {installments?.map((installment) => (
                <InstallmentData
                  referenceDateWithoutFormat={installment.Dt_referencia}
                  justificationId={installment.Id_justificativa}
                  key={installment.Dt_referencia + installment.Numero_parcela}
                  paymentStatus={installment.Status_pagamento}
                  paymentProof={installment.Comprovante}
                  installmentNumber={installment.Numero_parcela}
                  monthlyAmount={formatNumberToCurrency(installment.Valor)}
                  referenceDate={FormatLocaleDate(installment.Dt_referencia)!}
                  paymentDate={FormatLocaleDate(installment.Dt_repasse)!}
                />
              ))}
            </div>
          </ScrollArea>
        </div>
      </div>
    </div>
  )
}
